import { Next } from "koa"
import Router from "@koa/router"
import * as features from "../sdk/features"

export const requireSCIM: Router.Middleware = async (ctx: any, next: Next) => {
  await features.checkSCIM()
  await next()
}
